import { IBookFromPreviousTableStrategy } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/interfaces/book-from-previous-table-strategy.interface';
import { IDataTableQueryParams } from '@aca-new/app/shared/components/data-table/shared/models/interfaces/data-table-query-params.interface';
import { ITableBodyCell } from '@aca-new/app/shared/components/table/shared/interfaces/table-data.interface';
import { ITableHeader } from '@aca-new/app/shared/components/table/shared/interfaces/table-header.interface';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { PO_NO, PRODUCT_NAME_MULTIPLE, REF_NO, SERVICE_DATE, SERVICE_TYPE, SUPPLIER } from '@aca-new/app/shared/constants/table-header.constants';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { Injectable } from '@angular/core';
import { assign, cloneDeep, pickBy } from 'lodash/index';

@Injectable()
export class InspectionTableStrategyService implements IBookFromPreviousTableStrategy {
  public readonly userId: string = this._storageService.getItem(EStorageKeys.USER_ID);

  public tableUrlPath: string = `${SERVER_URL}/user/${this.userId}/psi-orders`;

  public tableHeaders: ITableHeader[] = [
    assign(cloneDeep(SERVICE_TYPE), { key: 'serviceType' }),
    assign(cloneDeep(SERVICE_DATE), { key: 'serviceDate', sortKey: 'serviceDate', width: '120' }),
    assign(cloneDeep(PRODUCT_NAME_MULTIPLE), {
      key: 'productNames',
      isFrontSort: true,
      width: '118',
      cellTransform(cellData: ITableBodyCell): void {
        cellData.label = cellData.label?.replace(/\//g, '###');
        cellData.value = 'TABLE.PRODUCTS';
      },
    }),
    assign(cloneDeep(SUPPLIER), { key: 'supplierName', width: '100' }),
    assign(cloneDeep(PO_NO), { key: 'poNumbers', isFrontSort: true, width: '120' }),
    assign(cloneDeep(REF_NO), { key: 'refNumber', width: '118' }),
  ];

  public constructor(protected readonly _storageService: StorageService) {}

  public getTableUrlParams(tableParams: IDataTableQueryParams): Record<string, string> {
    return pickBy({
      'businessType': 'AI',
      'keyword': tableParams.keyword,
      'page-size': tableParams.pageSize.toString(), // eslint-disable-line @typescript-eslint/naming-convention
      'page': tableParams.page.toString(),
      'sortType': tableParams.sortType,
      'sortField': tableParams.sortField || 'bookingDate',
    }) as Record<string, string>;
  }
}
